<template>
  <div>
    <!-- 부모가 있을 경우 -->
    <div class="card-top">
      <span />
    </div>

    <!-- 내용물 -->
    <div class="card-body" >
      <div class="card-content">
        <p>{{ value.title }}</p>
        <p>{{ value.name }}</p>
      </div>
    </div>

    <!-- 여러 자식이 있을 경우 -->
    <div v-if="value.child && value.child.length > 1" class="card-bottom">
      <span />
      <div class="bottom-bar" :style="{paddingLeft: paddingLeft(value), paddingRight: paddingRight(value)}">
        <span />
      </div>
    </div>

    <div class="child">
      <print-node v-for="child of value.child" :value="child"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrintNode',
  props: {
    value: Object,
  },
  methods: {
    paddingLeft (value) {
      const total = value.child[0].totalChildCount
      const padding = 5 * (total - 1)
      return `${(93 * total) + padding}px`
    },
    paddingRight (value) {
      const total = value.child[value.child.length - 1].totalChildCount
      const padding = 5 * (total - 1)
      return `${(93 * total) + padding}px`
    }
  }
}
</script>

<style lang="scss" scoped>
.card-top {
  display: flex; justify-content: center; height: 60px;
  span {  height: 100%; width: 1px; background-color: #cdcdcd;}
}

.card-bottom {
  height: 60px;
  & > span { display: block; height: 100%; width: 1px; margin: 0 auto; background-color: #cdcdcd;}
  .bottom-bar {
    width:100%;
    height:1px;
    & > span {
      display: block;
      width: 100%;
      height: 100%;
      background-color: #cdcdcd;
    }
  }
}

.child {
  display: flex;
  gap: 10px;
}

.card-body {
  display: flex;

  .card-content {
    margin: 0 auto;
    width: 186px;
    text-align: center;
    border: 1px solid #CDCDCD;

    p { padding: 10px 1rem; }
    p:first-child {
      border-bottom: 1px solid #CDCDCD;
      background-color: #F9F9F9;
      font-weight: 500;
    }
  }
}
</style>
